import React, {createContext, useContext, useState} from 'react';
import Icon from "../ui/components/Icon";
import {toast} from "react-toastify";

export const contextBigPlan = createContext({
    isToggle : false,
    isAuth : false,
    currentUser : {},
    setFilterToggle : () => {},
    //updateCurrentUserToggleBigPlan : () => {}
});

export const GrosPlanProvider = ({children, isToggle = false, isAuth = false, updateCurrentUserToggleBigPlan = ()=>{}}) => {

    const setFilterToggle = (data) => {
        setState({...state, ...data});
    }

    const initState = {
        isToggle,
        isAuth,
        setFilterToggle: setFilterToggle,
        updateCurrentUserToggleBigPlan: updateCurrentUserToggleBigPlan
    }

    const [state, setState] = useState(initState);

    if(state.isAuth !== isAuth){
         setFilterToggle({isAuth});
    }

    return (
        <contextBigPlan.Provider value={state}>
            {children}
        </contextBigPlan.Provider>
    )
}

export const BigPlanToggleSwitcher = () => {
    const state = useContext(contextBigPlan);


    const update = () => {
        let isToggle = !state.isToggle;
        state.setFilterToggle({isToggle});
        if(state.isAuth){
            state.updateCurrentUserToggleBigPlan({"displayBigPlan": isToggle})
        }
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_gp`, isToggle);

        let message = "Gros plans déverrouillés";

        if(!isToggle){
            message = "Gros plans verrouillés";
        }


        toast(message,{
            className: 'toast-background toast-success',
            bodyClassName: "toast-font toast-success",
            progressClassName: 'toast-loader toast-success'
        });
    };


    return (
        <div className={"cta-big-plan"} onClick={() => update()}>
            {state.isToggle ? <><Icon type={"unlock"} /><span className="gros-plan-label lock"></span></> : <><Icon type={"lock"} /><span className="gros-plan-label unlock"></span></>}
        </div>
    );
};

export const useBigPlanContext = () => React.useContext(contextBigPlan);